module.exports = __webpack_public_path__ + "img/weixin-pop.ccf34458.ccf34458.png";